<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="point-terms-of-service">
      <Title jpn="Condizioni d'uso delle monete" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">I presenti Termini di utilizzo (di seguito denominati "Termini di utilizzo di Coin") stabiliscono le condizioni per l'utilizzo di "Coin" (definito di seguito) su
              <a href="https://gtchaxonline.com/" target="_blank" >https://gtchaxonline.com/</a>
              (di seguito denominato "Servizio") fornito da Xero Place Co., Ltd. (di seguito denominato "Società").</span>
            <span class="text">Si prega di leggere attentamente i Termini di utilizzo delle monete prima di considerare l'acquisto di monete.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Articolo 1 - Definizione dei termini</span>
            <span class="text">Il significato dei termini contenuti nei seguenti articoli dei presenti Termini sarà quello specificato in ciascun articolo.</span>
            <span class="text">(1) Per “Contratto di utilizzo del servizio” si intende un contratto relativo all'utilizzo del Servizio.</span>
            <span class="text">(2) Per "utente del servizio" si intende la persona che ha stipulato un contratto di utilizzo del servizio con la nostra azienda.</span>
            <span class="text">(3) "Informazioni sull'account" indica le informazioni relative all'Utente del servizio che l'Utente del servizio ha registrato con il Servizio.</span>
            <span class="text">(4) "Moneta" indica una valuta che può essere utilizzata solo dalla nostra azienda.</span>
            <span class="text">(5) Il "saldo utilizzato" è il saldo delle monete detenute e disponibili per l'uso da parte dell'utente del servizio.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Articolo 2 - Moneta</span>
            <span class="text">(1) Gli utenti del Servizio possono acquistare Monete che possono essere utilizzate all'interno del Servizio utilizzando il metodo specificato dalla Società e al prezzo indicato dalla Società all'interno del Servizio. Inoltre, la Società può impostare unità di acquisto, metodi di pagamento, periodi di utilizzo e altre condizioni di acquisto per l'acquisto di monete per gli utenti del servizio, e le condizioni di acquisto impostate e l'importo da pagare, ecc. saranno pubblicati all'interno del Servizio o dei servizi gestiti dalla Società.</span>
            <span class="text">(2) Quando un utente del servizio esprime la propria intenzione di acquistare una moneta utilizzando il metodo prescritto dalla Società, verrà stabilito un contratto tra l'utente del servizio e la Società relativo all'acquisto della moneta e verrà determinato l'importo totale per l'acquisto.</span>
            <span class="text">(3) Se l'utente del servizio che acquista Coin è minorenne, l'utente del servizio deve ottenere il consenso di un genitore o tutore prima di acquistare Coin.</span>
            <span class="text">(4) Se un minore acquista una Moneta, la Società presumerà che la persona con autorità genitoriale abbia acconsentito all'acquisto della Moneta.</span>
            <span class="text">(5) Il saldo di utilizzo dell'utente del servizio visualizzato all'interno del Servizio sarà collegato alle informazioni sull'account e registrato nelle apparecchiature di telecomunicazione utilizzate per fornire il Servizio e altri servizi gestiti dalla Società.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Articolo 3 - Utilizzo della moneta</span>
            <span class="text">(1)La moneta può essere utilizzata per acquistare i nostri prodotti.</span>
            <span class="text">(2) Gli utenti del servizio possono acquistare prodotti forniti dalla Società entro l'importo del loro saldo in Coin.</span>
            <span class="text">(3) Se un utente del servizio utilizza Coin per acquistare un prodotto dalla Società, il prezzo del prodotto verrà detratto dal saldo Coin e l'importo sarà considerato pagato.</span>
            <span class="text">Salvo diversa indicazione, i Coin concessi gratuitamente dalla Società agli utenti dei servizi nell'ambito del Servizio verranno consumati preferenzialmente.</span>
            <span class="text">(4) Gli utenti del servizio possono controllare il saldo delle loro monete all'interno del servizio. Inoltre, gli utenti del servizio sono responsabili della gestione e del controllo dell'aumento e della diminuzione dei Coin.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Articolo 4 – Trattamento della moneta</span>
            <span class="text">(1) La Società concederà Monete all'Utente in conformità con il metodo stabilito dalla Società quando l'Utente acquista Monete nel Servizio, quando la Società conduce una campagna o in altri casi. L'unità di acquisto delle Monete, il prezzo, il periodo di validità e le altre condizioni per la concessione delle Monete saranno determinati dalla Società e visualizzati sul Servizio.</span>
            <span class="text">(2) Il periodo di validità della Moneta è di 6 mesi dalla data di concessione della Moneta.</span>
            <span class="text">(3) La Società non rimborserà le Monete acquisite dall'Utente, a meno che non sia richiesto dalla legge. In caso di rimborso di Monete in base a leggi e regolamenti, il metodo e le condizioni del rimborso verranno pubblicati separatamente secondo le modalità stabilite dalla Società.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Articolo 5 - Divieto di conversione in contanti, ecc.</span>
            <span class="text">Per quanto riguarda tutti i contenuti acquisiti all'interno di questo servizio, è vietato qualsiasi trasferimento, trasferimento, prestito, prestito, ecc. sotto forma di offerta o ricezione di denaro o altro compenso reale (incluso, ma non limitato a, il cosiddetto RMT [commercio di denaro reale]), sia direttamente, tramite l'intermediazione di terzi, aste su Internet o altri mezzi.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Articolo 6 - Trasferimento di monete, ecc.</span>
            <span class="text">Gli utenti del servizio non possono cedere, prestare, regalare o trasferire in altro modo monete o prodotti a terzi, né possono impegnare o fissare in altro modo un interesse di sicurezza.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Articolo 7 - Sospensione dell'acquisto e dell'uso delle monete, ecc.</span>
            <span class="text">Se un Utente del servizio rientra in una delle seguenti condizioni, la Società può adottare nei confronti dell'Utente del servizio le misure che la Società ritiene appropriate (inclusa, ma non limitata a, la sospensione dell'acquisto o dell'utilizzo di Coin).</span>
            <span class="text">(1) Se monete o prodotti vengono ottenuti o utilizzati con mezzi illegali</span>
            <span class="text">(2) Se l'utente del servizio viola le presenti Condizioni d'uso</span>
            <span class="text">(3) In altri casi in cui la Società determina che l'utilizzo del Servizio da parte dell'Utente è inappropriato.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Istituito il 28 febbraio 2025</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n_point_terms_of_service';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.point-terms-of-service{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .point-terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: black!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
